import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { IMPACT_POSTER_PLACEHOLDER, IMPACT_POSTER_GROUP_TWO_PLACEHOLDER } from '@core/constants/global-constants';
import { IImpact } from '@core/interfaces/imaking-an-impact';
@Component({
    selector: 'app-making-an-impact-cards',
    templateUrl: './making-an-impact-cards.component.html',
    styleUrls: ['./making-an-impact-cards.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MakingAnImpactCardsComponent implements OnInit {
  impacts: IImpact[] = []
  impactGroups: IImpact[][] = []
  poster = IMPACT_POSTER_PLACEHOLDER;
  impactPosterGroup = IMPACT_POSTER_GROUP_TWO_PLACEHOLDER;

  defaultGroupSize = 3;

  constructor() { }

  ngOnInit(): void {
    this.impacts = [...this.poster, ...this.impactPosterGroup];
    // Compute groups once so the template iterates a stable array reference.
    // Calling splitIntoGroups() directly in the @for produced a new array
    // every change-detection cycle (NG0100 under Angular 21's stricter CD).
    this.impactGroups = this.splitIntoGroups(this.impacts);
  }

  splitIntoGroups(array: IImpact[], groupSize: number = this.defaultGroupSize): IImpact[][] {
    const result: IImpact[][] = [];
    for (let i = 0; i < array.length; i += groupSize) {
      result.push(array.slice(i, i + groupSize));
    }
    return result;
  }
}
